import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import {
  selectCloneLeaguesSessionID,
  selectCloneLeaguesEditURLTemplate,
} from '../reducers/session_saver'

const useSyncSessionURL = () => {
  const sessionID = useSelector(selectCloneLeaguesSessionID)
  const editSessionURLTemplate = useSelector(selectCloneLeaguesEditURLTemplate)
  const hasSyncedRef = useRef(false)

  useEffect(() => {
    if (sessionID && !hasSyncedRef.current) {
      const editURL = editSessionURLTemplate.replace(':session_id', sessionID)

      if (window.location.pathname !== editURL) {
        window.history.replaceState(null, '', editURL)
        hasSyncedRef.current = true
      }
    }
  }, [ sessionID, editSessionURLTemplate ])
}

export default useSyncSessionURL
